import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BookNumReceiptDTO } from "../models/daybook-model";

@Injectable ({
    providedIn: 'root'
})

export class AnalyticsService {
    constructor(private http: HttpClient) {}

    lFN_PullAnalyticsData(l_fromDate: string, l_toDate: string) {
        return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/analytics/fromDate/` + l_fromDate + `/toDate/` + l_toDate , { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_ViewSummaryReportData(l_fromDate: string, l_toDate: string, isjsym: boolean) {
        return this.http.post(`${environment.ROOT_URL}/accountreports/summary/fromDate/` + l_fromDate + `/toDate/` + l_toDate + `/jsym/` + isjsym, null, { withCredentials: true, responseType: 'blob', observe: 'response' });
    }

    lFN_ViewDetailedReportData(l_reportData: BookNumReceiptDTO ) {
        return this.http.post(`${environment.ROOT_URL}/accountreports/detailed/`, l_reportData, { withCredentials: true, responseType: 'blob', observe: 'response' });
    }
}